document.addEventListener("click", function (event) {
  const openButton = event.target.closest(
    "[data-open-release]"
  );

  if (openButton) {
    event.preventDefault();

    const drawer = document.getElementById(
      "release-drawer"
    );

    const releaseHandle =
      openButton.getAttribute("data-open-release");

    if (!drawer || !releaseHandle) {
      return;
    }

    let matchedPanel = null;

    drawer
      .querySelectorAll("[data-release-panel]")
      .forEach(function (panel) {
        const matches =
          panel.getAttribute("data-release-panel") ===
          releaseHandle;

        panel.hidden = !matches;

        if (matches) {
          matchedPanel = panel;
        }
      });

    if (!matchedPanel) {
      return;
    }

    drawer.classList.add("is-open");
    drawer.setAttribute("aria-hidden", "false");

    document.body.classList.add(
      "release-drawer-open"
    );

    return;
  }

  const closeButton = event.target.closest(
    [
      "[data-close-release-drawer]",
      ".release-drawer__close",
      ".release-drawer-close",
      ".drawer__close",
      "[aria-label='Close']",
      "[aria-label='Close tracklist']",
      "[aria-label='Close release drawer']"
    ].join(",")
  );

  if (closeButton) {
    event.preventDefault();
    event.stopPropagation();
    closeDrawer();
    return;
  }

  const drawer = document.getElementById(
    "release-drawer"
  );

  if (
    drawer &&
    drawer.classList.contains("is-open") &&
    event.target === drawer
  ) {
    closeDrawer();
  }
});

document.addEventListener("keydown", function (event) {
  if (event.key === "Escape") {
    closeDrawer();
  }
});

function closeDrawer() {
  const drawer = document.getElementById(
    "release-drawer"
  );

  if (!drawer) {
    return;
  }

  drawer.classList.remove("is-open");
  drawer.setAttribute("aria-hidden", "true");

  document.body.classList.remove(
    "release-drawer-open"
  );

  drawer
    .querySelectorAll("[data-release-panel]")
    .forEach(function (panel) {
      panel.hidden = true;
    });
}